import { __awaiter, __assign, __generator } from '../node_modules/tslib/tslib.es6.js';
import { jsx } from 'react/jsx-runtime';
import { createContext, useState, useCallback, useEffect, useContext } from 'react';
import userService from '../services/user.service.js';

var initialState = {
    id: 0,
    buIds: "",
    email: "",
    firstName: "",
    lastName: "",
    phone: "",
    jobTitle: "",
    language: "",
    locale: "",
    timezone: "",
    avatar: "",
    orgName: "",
    lastModified: "",
    userType: "Org",
    status: "Active",
    roleLevel: "",
    isEditable: false,
    isMultiOrgAdmin: false,
    roles: ["USER"],
    sso: false
};
var userContext = createContext(null);
var UserProvider = function (_a) {
    var authApiBaseUrl = _a.authApiBaseUrl, children = _a.children;
    var _b = useState(initialState), user = _b[0], setUser = _b[1];
    var roles = user.roles;
    var primaryRole = roles[0];
    var isSuperAdmin = primaryRole === "SUPER_ADMIN";
    var isSupport = primaryRole === "TECH_SERVICES" || primaryRole === "SUPPORT";
    var isSysAdmin = isSuperAdmin || isSupport;
    var isCesAdmin = primaryRole === "BUSINESS_UNIT_ADMIN" ||
        primaryRole === "ORGANIZATION_ADMIN";
    var getUser = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, userService.getUser("me", authApiBaseUrl)];
                case 1:
                    res = _a.sent();
                    if (res) {
                        setUser(res);
                        window.dispatchEvent(new CustomEvent("userFetched"));
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [setUser, authApiBaseUrl]);
    useEffect(function () {
        getUser();
    }, [getUser]);
    return (jsx(userContext.Provider, __assign({ value: {
            user: user,
            reload: getUser,
            isSupport: isSupport,
            isSuperAdmin: isSuperAdmin,
            isSysAdmin: isSysAdmin,
            isCesAdmin: isCesAdmin
        } }, { children: children }), void 0));
};
var useUserContext = function () {
    var context = useContext(userContext);
    if (!context) {
        throw new Error("useUserContext must be used within a UserProvider");
    }
    return context;
};

export { UserProvider as default, useUserContext };
